// extracted by mini-css-extract-plugin
export default {"overlay":"gx-z","bodyOpen":"hx-z","content":"ix-z","header":"jx-z","close":"kx-z","closeNoHeading":"lx-z"};